import { ProductionFulfillmentApi, useAPIAction } from "melco-shared-logic";

export const useUploadInputFormat = () => {
  const [uploadInputFormat, isLoading] = useAPIAction(
    ProductionFulfillmentApi,
    async (api, file: File) => {
      const data = await api.productionFulfillmentFormatsUpload({ file });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "inputFormats.actions.add",
    }
  );

  return [uploadInputFormat, isLoading] as const;
};
